export default {"src":"/_next/static/media/hpb.d4590b79.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};